import type { MatchConfig } from '../proto';

/** Public lobby payload. Authentication IDs and email addresses never belong here. */
export interface PublicRoom {
  code: string;
  state: 'lobby' | 'playing';
  host_name: string;
  guest_name: string | null;
  config: MatchConfig;
  created_at: number;
  started_at: number | null;
}

export function roomClockLabel(clock: unknown): string {
  const c = clock as { initial_ms?: number; increment?: { type?: string; increment_ms?: number } } | null;
  if (!c || typeof c.initial_ms !== 'number') return '時間設定なし';
  const seconds = Math.round(c.initial_ms / 1000);
  const initial = seconds % 60 === 0 ? `${seconds / 60}分` : `${seconds}秒`;
  const increment = c.increment?.type === 'Fischer' ? c.increment.increment_ms ?? 0 : 0;
  return increment > 0 ? `${initial} ＋ ${increment / 1000}秒` : initial;
}

export function roomModeLabel(mode: string): string {
  if (mode === 'Sequential') return '交互に対局';
  if (mode === 'FullyParallel') return '各盤で対局';
  if (mode === 'StrictAlternate') return '交互に着手';
  return '同時に対局';
}
